import {FC, ForwardRefExoticComponent, ReactNode, RefAttributes} from 'react'
import {IconProps} from '@components/ui/icon/Icon.tsx'
import {StyledRowWarningTooltip} from '@components/commons/row-warning-tootlip/style.ts'

interface RowWarningTooltipProps {
    icon: ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>
    title: ReactNode
    paragraph: ReactNode
}
export const RowWarningTooltip: FC<RowWarningTooltipProps> = ({icon: Icon, title, paragraph}) => {
    return (
        <StyledRowWarningTooltip>
            <Icon size={16} />
            <div>
                <h3>{title}</h3>
                <p>{paragraph}</p>
            </div>
        </StyledRowWarningTooltip>
    )
}
